const Color ={
    txtInput: "#B6B6B6",
    primary: "#fff",
    txtColor: "#616161",
    colorBtn: "#1C355E",
    adminColor: "#536A82",
}

export default Color;